export default __webpack_public_path__ + "static/no-callBg-45de3eb98783d19bf2da1eb0a55d96d2.png";